enum TipoConvenio {
    Franquia = 0,
    Rede = 1
}

export default TipoConvenio;